export const attentionTxt = (lang: string, type: string, fromChat: boolean) => {
  if (type === "behavior") {
    return lang === "sv" ? "Dags att följa upp på ditt beteende" : "Time to follow up on your behavior";
  } else if (type === "task") {
    return lang === "sv" ? "Dags att följa upp på din fristående AI coaching" :
      "Time to follow up on your standalone AI coaching";
  } else if (type === "activity") {
    if (fromChat) {
      return lang === "sv" ? "Dags att följa upp på din AI coaching" : "Time to follow up on your AI coaching";
    } else {
      return lang === "sv" ? "Dags att följa upp på din aktivitet" : "Time to follow up on your activity";
    }
  } else if (type === "subGoal") {
    return lang === "sv" ? "Dags att följa upp på ditt delmål" : "Time to follow up on your sub-goal";
  } else if (type === "action") {
    return lang === "sv" ? "Dags att följa upp på din aktivitet" : "Time to follow up on your action";
  }
  return "N/A for " + type;
}